var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#4f4f4f",
    height: 12,
    viewBox: "0 0 12 12",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.75 9.184v1.774c0 .163.128.292.292.292h1.773c.076 0 .152-.03.204-.088l6.37-6.364L7.202 2.61.838 8.975a.286.286 0 00-.088.21zm10.33-6.078a.58.58 0 000-.822L9.717.919a.58.58 0 00-.823 0L7.826 1.986l2.187 2.188z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.12dd14589e81d8314a6b7756ccc966f5.svg";
export { ForwardRef as ReactComponent };